import React, { Component } from 'react';
import { Target, BarChart3, Calendar, Database, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export const WhatWeDo = () => {
  const systemComponents = [{
    icon: Target,
    title: 'Rebuild comp to pay for hunters, not seat‑warmers',
    description: 'Simple comp plans for each role tied to focused KPIs, so reps know how to win and top producers are rewarded.'
  }, {
    icon: BarChart3,
    title: 'Define the right KPIs with dashboards and leaderboards',
    description: 'Three layers – activity, effectiveness, outcomes – wired into live dashboards so the scoreboard becomes the loudest voice.'
  }, {
    icon: Calendar,
    title: 'Install a daily and weekly Sales Operating Rhythm',
    description: 'Daily huddles, weekly pipeline reviews, coaching 1:1s, roleplays, and follow‑up standards – the drumbeat your team runs on.'
  }, {
    icon: Database,
    title: 'Turn your CRM into the actual operating system',
    description: 'Rebuild pipeline stages, set entry/exit criteria, and enforce rules so CRM becomes the single source of truth.'
  }, {
    icon: Users,
    title: 'Shift culture and equip leaders to run the system',
    description: 'Use leaderboards, contests, and clear SOPs to smoke out bad reps, turn rookies into winners, and let your sales leader run the floor.'
  }];
  return <div className="w-full py-10 sm:py-16 md:py-24" data-id="element-303">
      <div className="max-w-5xl mx-auto px-4" data-id="element-304">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-3 sm:mb-4 text-[#F5F5F7] text-center leading-tight" data-id="element-305">
          What We Do: The $100M Sales Team Operating System
        </h2>
        <p className="text-center text-sm sm:text-base md:text-lg text-[#F5F5F7]/70 mb-8 sm:mb-12 max-w-3xl mx-auto" data-id="element-306">
          We install a $100M Sales Team Operating System that makes your current
          team behave like a professional, high‑performing sales org.
        </p>

        <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-12" data-id="element-307">
          {systemComponents.map((component, index) => {
          const Icon = component.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-gradient-to-br from-[#0A1BFF]/10 to-[#6366F1]/10 backdrop-blur-sm border border-[#6366F1]/20 rounded-xl p-4 sm:p-6 md:p-8" data-id="element-308">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-309">
                  <div className="bg-gradient-to-br from-[#6366F1] to-[#7C3AED] p-2 sm:p-3 rounded-lg flex-shrink-0" data-id="element-310">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#F5F5F7]" data-id="element-311" />
                  </div>
                  <div data-id="element-312">
                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#F5F5F7] mb-1 sm:mb-2" data-id="element-313">
                      {component.title}
                    </h3>
                    <p className="text-[#F5F5F7]/70 text-xs sm:text-sm md:text-base" data-id="element-314">
                      {component.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="max-w-3xl mx-auto space-y-4 sm:space-y-6 mb-8 sm:mb-12" data-id="element-315">
          <div className="flex items-start gap-3 sm:gap-4 bg-gradient-to-r from-[#0A1BFF]/5 to-transparent p-4 sm:p-6 rounded-xl border-l-4 border-[#1457FF]" data-id="element-316">
            <div className="w-2 h-2 bg-[#1457FF] rounded-full mt-1.5 sm:mt-2 flex-shrink-0" data-id="element-317" />
            <p className="text-[#F5F5F7]/90 text-sm sm:text-base md:text-lg" data-id="element-318">
              Turn 7–8 figure sales teams (5–30 reps) into a floor full of
              hunters.
            </p>
          </div>
          <div className="flex items-start gap-3 sm:gap-4 bg-gradient-to-r from-[#6366F1]/5 to-transparent p-4 sm:p-6 rounded-xl border-l-4 border-[#6366F1]" data-id="element-319">
            <div className="w-2 h-2 bg-[#6366F1] rounded-full mt-1.5 sm:mt-2 flex-shrink-0" data-id="element-320" />
            <p className="text-[#F5F5F7]/90 text-sm sm:text-base md:text-lg" data-id="element-321">
              Increase revenue per rep from the same lead flow by fixing comp,
              KPIs, dashboards, cadence, and CRM.
            </p>
          </div>
          <div className="flex items-start gap-3 sm:gap-4 bg-gradient-to-r from-[#7C3AED]/5 to-transparent p-4 sm:p-6 rounded-xl border-l-4 border-[#7C3AED]" data-id="element-322">
            <div className="w-2 h-2 bg-[#7C3AED] rounded-full mt-1.5 sm:mt-2 flex-shrink-0" data-id="element-323" />
            <p className="text-[#F5F5F7]/90 text-sm sm:text-base md:text-lg" data-id="element-324">
              Get out of "super closer" mode and run your team off a scoreboard,
              not your personality.
            </p>
          </div>
        </div>

        <CTAButton className="mt-6 sm:mt-8" data-id="element-325" />
      </div>
    </div>;
};